<template>

  <div class="main-top">
    <search-from>
      <template slot="default">
        <slot name="default"></slot>
      </template>
      <template slot="shrink">
        <slot name="shrink"></slot>
      </template>
    </search-from>
    <slot name="searchForm"></slot>
    <el-row class="elRow">
      <slot name="query"></slot>
      <f-button v-if="show==false" icon="unfold" @click="handleClick(true)" :icon-size="14">展开</f-button>
      <f-button v-if="show==true" icon="packup" @click="handleClick(false)" :icon-size="14">收起</f-button>

    </el-row>
    <!--<div style="position: absolute;bottom: 0;width: 100%">-->
    <!--<div>缩放</div>-->
    <!--</div>-->
  </div>


</template>

<script>
import { EventBus } from '../../utils/event-bus';
  export default {
    name: "index",
    data() {
      return {show: false}
    },
    props: {
      value: {
        type: Boolean,
        default: false

      }
    },

    methods: {
      handleClick(state) {
        this.show = state;
        this.$emit("input", this.show);
         this.$nextTick(()=>{
            var height = $(".main-top").outerHeight(true);
            this.$emit('searchBorderClick',height)
         })
      }
    }

  }
</script>

<style scoped>
  .tips {
    color: #086BAF;
    text-align: center;
    text-decoration: #086BAF;
    margin-left: -20px;
    margin-right: 10px;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/SearchFormWrap/index.vue